// extracted by mini-css-extract-plugin
module.exports = {"number":"GiftCard_number__2K_B7","wrapper":"GiftCard_wrapper__wLBSe","text":"GiftCard_text__3MKpc"};